import service from '@/api/medicines';
import {loading, alert, handleError} from '@/state/generators/helpers';

export const state = {
    service: service('admin/medicines')
};

export const actions = {
    updateMedicine: function ({commit, state}, {id, data}) {
        loading(commit);

        return state.service.update(id, data, 'put').then(response => {
            commit('REPLACE_ITEM', response.data);
            commit('SET_ITEM', response.data);
            commit('SET_ERRORS', {});
            alert(commit, this.$t('request.save_is_successful'));
            loading(commit, false);
            return response.data;
        }).catch((e) => {
            return handleError(e, commit);
        });
    },

    deactivate: function ({commit, state}, id) {
        loading(commit);

        return state.service.deactivate(id).then(response => {
            commit('REPLACE_ITEM', response.data);
            alert(commit, this.$t('request.save_is_successful'));
            loading(commit, false);
            return response.data;
        }).catch((e) => {
            handleError(e, commit);
            throw e;
        });
    }
};
